module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak",
      "title": "29"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('div', {
    staticClass: "chap_surtit"
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "chap1",
      "role": "presentation",
      "src": "images/chap1.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_vm._v("BEFORE WE SET ")]), _vm._v("out on the path of Paul’s vision of justification in Scripture, it is important to do some preliminary orienteering in this chapter in order to establish the trailhead. Having exposed the potential inadequacy of many of the prevailing arguments for what fueled the engine of Cranmer’s liturgical redaction, we have proposed a theory that it is justification by faith alone which chiefly propelled the Archbishop’s editorial decisions. We would do well to begin by observing examples in his nonliturgical work which illustrate just how highly Cranmer prioritized justification by faith alone in his theological thinking. It seems increasingly common in our day and age for Protestants, at least on the popular level, to place "), _c('i', [_vm._v("sola fide")]), _vm._v(" as an equal among many other important doctrines. This was not the case for Cranmer.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The reason we want to even briefly observe the governing position of "), _c('i', [_vm._v("sola fide ")]), _vm._v("in Cranmer’s thinking "), _c('i', [_vm._v("outside")]), _vm._v(" his liturgical work is because, as we will see, his application of "), _c('i', [_vm._v("sola fide")]), _vm._v(" to liturgy is more structural and subterranean, which is probably why it has often gone unnamed or unidentified. Liturgy does not explain theology. It does theology."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-071",
      "id": "ap_ntb-071-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" We must find explanation elsewhere before we can fully appreciate how the content and structure of the Book of Common Prayer were shaped and governed by "), _c('i', [_vm._v("sola fide")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What we hope to establish here is that, as one scholar put it, “Christ-centered theology was the lens through which [Cranmer] studied everything.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-072",
      "id": "ap_ntb-072-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" To do so, we will focus on two central theological hot topics which dominated "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak",
      "title": "30"
    }
  }, [_vm._v("debate in sixteenth-century Europe—purgatory and the Lord’s Supper. We zero in on these two doctrinal spheres because in a short amount of space they shed the broadest light on how the editorial decisions of Cranmer were governed by justification by faith alone.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006",
      "lang": "en-US"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("GOSPEL-CENTERED ESCHATOLOGY: CRANMER ON PURGATORY")]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After his thorough and groundbreaking study on medieval theology and practice Eamon Duffy concluded, “There is a case for saying that "), _c('i', [_vm._v("the")]), _vm._v(" defining doctrine of medieval Catholicism was Purgatory.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-073",
      "id": "ap_ntb-073-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" This belief in the penitential, pre-heaven afterlife was not peripheral in medieval theology, nor was it a distant concern in the average medieval Christian’s psyche. Purgatory was the engine block that held up the propulsion system of medieval piety, motivating countless Christians to give blood, sweat, tears, and—yes—money to Christ and his church. It is tempting for Protestants now to look back on the sixteenth century and read modernist motivations into the Reformation critique of purgatory: it is superstition built on extrabiblical sources and tradition. And while this understanding of the critique is true, it was not the center of the problem for the sixteenth-century Reformers.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To be sure, Cranmer articulated the baseline argument that purgatory was simply not found in the Scriptures. It is telling that in the first authorized English Bible—the so-called Matthew Bible of 1537, overseen by Cranmer—extensive notes were written on the classic purgatory prooftext of Ezekiel 18. In the margins of this Bible were “provocatively Protestant” annotations, which Stephen Sykes summarizes:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("God’s forgiveness is final and irrevocable, says the commentary, sharply dissenting from the “sophisters” who teach the necessity of seven years’ punishment in purgatory, tartly adding: “If this is not to mock with God and his Holy Word, I wot not what is mockage.” The response of God to the sinner’s radical repentance is an equally radical forgiveness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-074",
      "id": "ap_ntb-074-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak",
      "title": "31"
    }
  }, [_vm._v("And yet Cranmer’s concern about purgatory was not merely that it was extrabiblical. His more pointed (and still thoroughly biblical) concern was that purgatory undermined justification "), _c('i', [_vm._v("sola fide")]), _vm._v(". In the Archbishop’s words:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What a contumely and injury is this to Christ, to affirm that all have not full and perfect purgation by his blood, that die in his faith! Is not all our trust in the blood of Christ, that we be cleansed, purged, and washed thereby? And will you have us now to forsake our faith in Christ, and bring us to the pope’s purgatory to be washed therein; thinking that Christ’s blood is an imperfect lee or soap that washeth not clean?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-075",
      "id": "ap_ntb-075-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Purgatory was an untenable doctrine for Cranmer precisely because it sought purgation by a means other than Christ’s blood. It diminished the finished work of Christ by insisting Christ’s work was actually something "), _c('i', [_vm._v("un")]), _vm._v("finished. Worse yet, this unfinished work was to be completed not by Jesus but by the believer. Cranmer would have seen this as a complete reversal of Paul—not Christ, but I; not by faith, but by works. "), _c('i', [_vm._v("Sola fide, ")]), _vm._v("for Cranmer, stood above eschatology as a governor, a sentinel which would guard and protect what doctrine would pass through the gates of sound teaching. Put another way, justification for Cranmer was an integrated doctrine: "), _c('i', [_vm._v("sola fide ")]), _vm._v("was not merely a soteriological reality; it was eschatological as well.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007",
      "lang": "en-US"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("GOSPEL-CENTERED SACRAMENTOLOGY: CRANMER ON THE LORD’S SUPPER")]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While much of the landscape of Cranmer’s sacramentology appears to have already been mined,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-076",
      "id": "ap_ntb-076-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" we find only a few of those efforts drilling past the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak",
      "title": "32"
    }
  }, [_vm._v("depths of politics, metaphysics, medieval philosophy, and even biblical prooftexting to its subterranean bedrock."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-077",
      "id": "ap_ntb-077-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" While all the above influences are certainly at play in Cranmer’s thought, we might observe with some scholars a more fundamental conviction that lay at the base of his eventual sacramental landing place—Cranmer’s understanding of justification—which could provide a more helpful and thorough explanation for the “why” of his mature sacramental thinking. Peter Brooks’s study of Cranmer’s sacramentology concludes that Cranmer built “his whole sacramental superstructure on that doctrine basic to all Reformed theology—the concept of "), _c('i', [_vm._v("justificatio sola fide.")]), _vm._v("” Likewise Gordon Jeanes could comfortably say at the outset of his extensive analysis that Cranmer’s “sacramental theology evolved in the context of his understanding of justification.” And, most notably, Ashley Null’s conclusion after thorough inquiry into Cranmer’s thinking is that “ultimately, Cranmer’s Eucharistic teaching was determined by his doctrine of justification.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-078",
      "id": "ap_ntb-078-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What we want to observe here is that Cranmer subsumed his sacramentology under his soteriology."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-079",
      "id": "ap_ntb-079-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" It is telling, for instance, that in the 1547 Book of Homilies, which were intended by Cranmer to be the total homiletical content of nearly all English pulpits under his leadership and England’s “doctrinal plumb line,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-080",
      "id": "ap_ntb-080-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" there is no considerable focus on the sacraments."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-081",
      "id": "ap_ntb-081-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Instead, there is an intense focus on the doctrine of justification by faith alone, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "role": "doc-pagebreak",
      "title": "33"
    }
  }, [_vm._v("garnering the attention of three of six central doctrinal homilies: “Of the salvation of all mankind,” “Of the true and lively faith,” and “Of good works.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-082",
      "id": "ap_ntb-082-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Perhaps all this is a nod to Cranmer’s thinking: when justification is rightly preached alongside a well-ordered liturgy, the sacramental discussion is much more rightly framed. Let us observe how this might be so by exploring the way Cranmer defines a sacrament and articulates its purpose, which in turn will help us see "), _c('i', [_vm._v("why ")]), _vm._v("he argues against superstition, transubstantiation, and the medieval understanding of the priesthood.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_c('i', [_vm._v("Cranmer’s definition of a sacrament. ")])]), _vm._v("Ashley Null’s research yields this conclusion: Cranmer defined a sacrament as “only something that the New Testament recorded as being commanded by Christ for the forgiveness of sins.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-083",
      "id": "ap_ntb-083-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" It is typically Protestant to note, against the Roman Catholic system of seven sacraments, that a sacrament is only something which is explicitly commanded and instituted by Christ (ruling out unction, marriage, and the like). But Cranmer’s even more pointed criterion is nothing other than justification itself—that which is “commanded by Christ "), _c('i', [_vm._v("for the forgiveness of sins")]), _vm._v(".”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-084",
      "id": "ap_ntb-084-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" This criterion is evident in Cranmer’s treatment of the Lord’s Supper in the parliamentary debate of 1548. Commenting there on the phrase "), _c('i', [_vm._v("hoc est corpus meum, ")]), _vm._v("he responds, “He that maketh a will bequeaths certain legacies, and this is our legacy: "), _c('i', [_vm._v("Remission of sins")]), _vm._v(", which those only receive that are members of his body.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-085",
      "id": "ap_ntb-085-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" We also hear it in Cranmer’s response to Henry’s corrections of the Bishops’ book on why marriage cannot be a sacrament. The Archbishop argues against Henry’s articulation of the virtue and efficacy of the seven sacraments thus: “The causes [of grace] may not be well applied to matrimony: that it should be, as the other [sacraments] were, by the manifest institution of Christ: or, that it is of necessity to salvation: or, that thereby we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "role": "doc-pagebreak",
      "title": "34"
    }
  }, [_vm._v("should have the forgiveness of sins, renovation of life, and justification, &c.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-086",
      "id": "ap_ntb-086-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" When it comes particularly to baptism and the Lord’s Supper, we find Cranmer time and again at pains to establish this evangelical grounding for his sacramental convictions. In other words, the purpose of a sacrament, according to Cranmer, is to preach the gospel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-087",
      "id": "ap_ntb-087-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" In fact, in discussions differentiating the two Protestant sacraments from the seven of medieval theology, Cranmer would call baptism and the Lord’s Supper “sacramentes of the gospell.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-088",
      "id": "ap_ntb-088-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_c('i', [_vm._v("Cranmer’s understanding of the purpose of a sacrament: the theology of promise.")])]), _vm._v(" It is precisely at this point of sacramentology where we might first observe how similar Cranmer’s articulation of the gospel is to Martin Luther’s, focusing particularly on the idea central to the Wittenberg reformer’s understanding of "), _c('i', [_vm._v("sola fide")]), _vm._v(": faith is that which lays hold of God’s promises. There may be no better summary of this theology of promise than Luther’s "), _c('i', [_vm._v("The Babylonian Captivity of the Church ")]), _vm._v("(1520) and passages in Melanchthon’s "), _c('i', [_vm._v("Loci Communes ")]), _vm._v("(1521)"), _c('i', [_vm._v(". ")]), _vm._v("It is telling, in the former, that the center of Luther’s theology of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "role": "doc-pagebreak",
      "title": "35"
    }
  }, [_vm._v("justification—"), _c('i', [_vm._v("promissio")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-089",
      "id": "ap_ntb-089-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v("—was articulated in a "), _c('i', [_vm._v("sacramental ")]), _vm._v("discussion. The reason that the sacrifice of the mass was an untenable doctrine was because justification was indeed "), _c('i', [_vm._v("sola fide, ")]), _vm._v("through the promise: “If the mass is a promise . . . then access to it is to be gained, not with any works, or powers, or merits of one’s own, but by faith alone. For where there is the Word of the promising God, there must necessarily be the faith of the accepting man.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-090",
      "id": "ap_ntb-090-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" In the "), _c('i', [_vm._v("Loci Communes")]), _vm._v(", Luther’s compatriot defines the gospel most succinctly as “the "), _c('i', [_vm._v("promise")]), _vm._v(" of God’s grace, blessing, and kindness through Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-091",
      "id": "ap_ntb-091-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Later, after tracing faith from Adam and Eve, to the Patriarchs, to Noah, through David, Melanchthon concludes: “The word that faith trusts is simply the "), _c('i', [_vm._v("promise")]), _vm._v(" of God’s mercy and grace.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-092",
      "id": "ap_ntb-092-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Likewise, we find that in Melanchthon’s 1531 "), _c('i', [_vm._v("Apology of the Augsburg Confession")]), _vm._v(" the language of “promise” is used liberally, especially throughout Article IV (on justification) where “promise” is often interchanged with “gospel,” or at least features as the chief term in defining the gospel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-093",
      "id": "ap_ntb-093-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That Cranmer is clued in to this promise-centered soteriology is evident throughout his work in the 1530s and 1540s. In his Homily on Scripture, Cranmer says that the Bible’s strength is in its “power to convert through God’s promise.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-094",
      "id": "ap_ntb-094-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Elsewhere in his Homily on Salvation: “Faith doth directly send us to Christ for remission of our sins, and that by faith given us of God we embrace the promise of God’s mercy and of the remission of our sins.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-095",
      "id": "ap_ntb-095-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "role": "doc-pagebreak",
      "title": "36"
    }
  }, [_vm._v("Almost a decade earlier, in a passage that sounds very Lutheran, Cranmer responds to Henry with this definition of faith: “He that hath assured hope and confidence in Christ’s mercy hath already entered into a perfect faith, and not only hath a will to enter into it. For perfect faith is nothing else but assured hope and confidence in Christ’s mercy: and after it followeth, that he shall enter into perfect faith by undoubted trust in God, in his words and promise.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-096",
      "id": "ap_ntb-096-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In Cranmer’s exhortation preceding the 1544 Litany, which might well function as an early manifesto of all of the Archbishop’s liturgical work, we hear the language of promise liberally used:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Our father in heaven, of his mere mercy and infinite goodness, hath bounden himself by his own free promise . . .")]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But now good Christian people, that by the true use of prayer we may obtain and enjoy his gracious promise of aid, comfort, and consolation, in all our affairs and necessities . . .")]), _c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We must, upon consideration of our heavenly Father’s mercy and goodness towards us, and of his everlasting truth, and free promise made unto us in his own holy word, conceive a full affiance, hope, and trust."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-097",
      "id": "ap_ntb-097-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Turning now to the sacraments, what we discover dominating the landscape of Luther’s and Melanchthon’s teaching is precisely this same promise-theology. Selections from Melanchthon: “Sacraments or signs of God’s mercy have been added to the promises . . . and they have a most certain testimony that God’s goodwill applies to us”;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-098",
      "id": "ap_ntb-098-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" “The signs of Baptism and participation in the Lord’s Supper have been added to the promises as the autographs of Christ, so that Christians may be certain that their sins are forgiven”;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-099",
      "id": "ap_ntb-099-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" “In the Scriptures signs are added to the promises as seals, both to remind us of the promises and to serve as sure testimonies of God’s goodwill toward us, confirming that we will certainly receive what God has promised”;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-100",
      "id": "ap_ntb-100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" “Nothing "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "role": "doc-pagebreak",
      "title": "37"
    }
  }, [_vm._v("can be called a sacramental sign except those signs that have been attached to God’s promises”;"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-101",
      "id": "ap_ntb-101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" “In the church the Lord’s Supper was instituted that our faith might be strengthened by the remembrance of the promises of Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-102",
      "id": "ap_ntb-102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In 1526, Luther articulated that the same promises preached corporately in a sermon are re-preached individually in the Lord’s Supper:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When I preach his death, it is in a public sermon in the congregation, in which I am addressing myself to no one individually; whoever grasps it, grasps it. But when I distribute the sacrament, I designate it for the individual who is receiving it; I give him Christ’s body and blood that he may have forgiveness of sins, obtained through his death, and preached in the congregation. This is something more than the congregational sermon; for although the same thing is present in the sermon as in the sacrament, here is the advantage that it is directed at definite individuals. In the sermon one does not point out or portray any particular person, but in the sacrament it is given to you and to me in particular, so that the sermon comes to be our own."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-103",
      "id": "ap_ntb-103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This “same thing present” in sermon and sacrament is understood by Luther to be this justifying word of forgiveness—God’s promise. It is precisely for this reason that Luther could not imagine leaving the Roman mass liturgically untouched for, especially in its late medieval theological and liturgical context, the mass obscured the gospel. It made the sacrament a work rather than a gift, a means of earning rather than a word of promise. Bryan Spinks observes:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For Luther, the canon is a serious problem. It is in fact something that is incompatible with the gospel, and has in fact taken the place of the gospel. . . . Luther believed the gospel to be a declaration of the love and forgiveness of God—of what God had done for us. The canon, however, is preoccupied with what we are doing for God. It was precisely this which meant that the canon was incompatible with the doctrine of justification."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-104",
      "id": "ap_ntb-104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "role": "doc-pagebreak",
      "title": "38"
    }
  }, [_vm._v("Debates about Cranmer’s sacramentology have often failed to observe Luther’s identical line of thinking in Cranmer’s. Perhaps this is due to the fact that the debate has centered around sacramental "), _c('i', [_vm._v("presence")]), _vm._v(", where the mature Cranmer, taking a Reformed position, was in disagreement with Luther."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-105",
      "id": "ap_ntb-105-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" This disagreement has obscured what is actually a more fundamental agreement about the sacramental "), _c('i', [_vm._v("purpose")]), _vm._v("—to freely give out the promises of God to his people. Once this is recognized, we begin to see echoes of Luther and Melanchthon all over Cranmer’s writing. In the Ten Articles of 1536, Cranmer describes baptism as necessarily including “firm credence and trust in the promise of God adjoined to the said sacrament.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-106",
      "id": "ap_ntb-106-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" In 1550, Cranmer would describe that true reception of the Lord’s Supper was a “sacramental feeding in Christ’s promises.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-107",
      "id": "ap_ntb-107-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Again, according to Cranmer, a sacrament’s purpose is that God might “assure [the believer] by the promise of his word.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-108",
      "id": "ap_ntb-108-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" As Caroline Stacey summarized Cranmer’s sacramental theology: “The gospel promises do not point to the sacraments as special means of grace, but rather the sacraments are really visible showings of the gospel promises, as preaching is an audible showing of the same promises . . . they do not ‘add grace’ to the gospel.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-109",
      "id": "ap_ntb-109-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Indeed, they "), _c('i', [_vm._v("give")]), _vm._v(" the gospel of grace.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The net effect of this insight is that the same gospel of justification by faith alone which drove the sacramental thinking of Luther dominated Cranmer’s thought process as well. The purpose of the sacraments, according to Cranmer, was to preach the gospel, particularly by giving the promises of God. Suddenly, sense is made of the fact that in the 1552 Prayer Book Cranmer loaded both sacramental rites with promise-theology. Stephen Sykes notes the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "role": "doc-pagebreak",
      "title": "39"
    }
  }, [_vm._v("unprecedented rise in “promise” language throughout the baptism liturgy of 1552, concluding that “the historical reason [for this] has doubtless much to do with the promissory emphasis of Luther’s sacramental theology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-110",
      "id": "ap_ntb-110-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" In Holy Communion, Cranmer architected the Comfortable Words to follow Absolution—the Comfortable Words being nothing other than four bald promises of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-111",
      "id": "ap_ntb-111-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" It is clear that for Cranmer, his sacramentology is governed by the gospel, rendering an outlook succinctly described by Ashley Null as “justification and Holy Communion sola fide"), _c('i', [_vm._v(".")]), _vm._v("”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-112",
      "id": "ap_ntb-112-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" J. I. Packer summarizes:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For [Cranmer], as for all the Reformers, the doctrine of justification by faith alone compelled a drastic rethinking of the sacraments. For if sacraments are really means of grace . . . and if grace means the apprehended reality of one’s free forgiveness, acceptance, adoption, in and through Christ, and if grace is received by faith, and if faith is essentially trust in God’s promise, then the sacraments must be thought of as rites which display and confirm the promises of the gospel, and as occasions for faith’s exercise and deepening. From this it will follow that, instead of the gospel being really about the sacraments, as means for conveying specific spiritual blessings given no other way (the Medieval thesis), the sacraments are really about the gospel, in the sense that they hold forth visibly the same promises."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-113",
      "id": "ap_ntb-113-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_c('i', [_vm._v("Superstition and transubstantiation as gospel-issues.")])]), _vm._v(" With "), _c('i', [_vm._v("sola fide")]), _vm._v(" established as the governor of Cranmer’s sacramentology, we can now revisit other loci of Cranmer’s sacramental argumentation and hear afresh this same governor featured there. Many have observed how the mature Cranmer was allergic to what he and the other Reformers described as “superstition.” But were such attitudes merely the byproducts of the new humanist rationality and the early modernist outlook? For Cranmer, while this "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "role": "doc-pagebreak",
      "title": "40"
    }
  }, [_vm._v("rationale was doubtless at play,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-114",
      "id": "ap_ntb-114-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" when it came to grappling with the metaphysics of bread and wine, his stated reasoning had far less to do with humanist disdain for medieval primitive practice and far more to do with the gospel. It is "), _c('i', [_vm._v("sola fide")]), _vm._v(" which motivates statements like these that seek to distinguish the elements themselves from what they signified and sealed: “Consider and behold my body crucified for you; that eat and digest in your minds. Chaw you upon my passion, be fed with my death. This is the true meat, this is the drink that moisteneth. . . . The bread and the wine which be set before your eyes are only "), _c('i', [_vm._v("declarations of me")]), _vm._v(", but I myself am the eternal food.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-115",
      "id": "ap_ntb-115-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Superstition, aided and abetted by the doctrine of transubstantiation which said that the bread and wine substantially turned into the body and blood of Christ, was problematic not because it was antiquated or thought unfit for modern, rational thinking. Instead, these practices were manifestations of a more fundamental loss of scriptural truth, particularly the truth of justification by faith alone. In Cranmer’s argumentation, if bread and wine are transubstantiated, people can receive Christ by means other than faith. They can receive Christ and be united to him substantially by simply physically eating the sacrament."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-116",
      "id": "ap_ntb-116-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" This further makes sense of why in the debates on transubstantiation in sixteenth-century England the location of Christ was ultimately an issue of the gospel. In Cranmer’s understanding, the book of Hebrews locates Christ bodily in heaven, and in heaven for a purpose—that he might live to intercede for believers as he declares his finished work before the Father (Heb 7:25). This good news of Christ’s heavenly intercession is in his mind jeopardized, which is why he says, “Our faith is not to believe him to be in bread and wine, but that he is in heaven.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-117",
      "id": "ap_ntb-117-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" For Cranmer, transubstantiation pulls Christ away from heaven, away from the ear of the Father where intercession is to be made. Against transubstantiation, in the Archbishop’s words, communion exists not to pull Christ down, but to lift us up: “Being like eagles in this life, we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "role": "doc-pagebreak",
      "title": "41"
    }
  }, [_vm._v("should fly up into heaven in our hearts, where that Lamb is resident at the right hand of his Father, which taketh away the sins of the world.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-118",
      "id": "ap_ntb-118-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" The concern about superstitious practices associated with transubstantiation (reservation, elevation, and veneration of the sacrament, processions and festivals, etc.) is therefore not a relatively insignificant metaphysical one, but a life-or-death soteriological one."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-119",
      "id": "ap_ntb-119-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" And this scheme creates a doctrinal order of priority. Contrary to medieval piety, the sacraments were not to be focused on for their sake. They were to be vehicles and servants of the gospel. For Cranmer, "), _c('i', [_vm._v("sola fide ")]), _vm._v("would govern the metaphysics of Christ’s presence at the table.")])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_c('i', [_vm._v("Priesthood and ecclesiology as gospel-issues. ")])]), _vm._v("We see from yet another angle that Cranmer’s critique of medieval sacramental theology is governed by "), _c('i', [_vm._v("sola fide")]), _vm._v(" in the way he criticizes his day’s theology of the priesthood. If faith alone must be in "), _c('i', [_vm._v("Christ alone")]), _vm._v(", any other mediator nullifies the aloneness of faith: the object of faith (Christ) must be as alone as the faith itself for justification to be truly "), _c('i', [_vm._v("by faith alone")]), _vm._v(". "), _c('i', [_vm._v("Sola fide ")]), _vm._v("and "), _c('i', [_vm._v("solus Christus ")]), _vm._v("are joined at the hip. This is why Cranmer can thunder against the priesthood thus:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The greatest blasphemy and injury that can be against Christ, and yet universally used through the popish kingdom, is this: that the priests make their mass a sacrifice propitiatory, to remit the sins as well of themselves as of other, both quick and dead, to whom they list [i.e., desire] to apply the same. Thus, under the pretense of holiness, the papistical priests have taken upon them to be Christ’s successors, and to make such an oblation and sacrifice as never creature made but Christ alone, neither he made the same any more times than once, and that was by his death upon the cross."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-120",
      "id": "ap_ntb-120-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is furthermore why Cranmer found the doctrine of apostolic succession untenable."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-121",
      "id": "ap_ntb-121-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" It was not ultimately his disdain for Roman theology as such or even his loyalty to Henry’s authority over that of the pope. Cranmer’s gospel-governed concern was that as priests were pretending to be "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "role": "doc-pagebreak",
      "title": "42"
    }
  }, [_vm._v("duplications, or “successors,” of Christ as they made a sacrifice of him,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-122",
      "id": "ap_ntb-122-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" they take the trust and faith which should be thrown upon Christ alone and direct it to themselves. And when that happens, faith is no longer alone—the work of another, the priest, must accompany it:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For if only the death of Christ be the oblation, sacrifice, and price, wherefore our sins be pardoned, then the act or ministration of the priest cannot have the same office. Wherefore it is an abominable blasphemy to give that office or dignity to a priest which pertaineth only to Christ; or to affirm that the Church hath need of any such sacrifice; as who should say, that Christ’s sacrifice were not sufficient for the remission of our sins; or else that his sacrifice should hang upon the sacrifice of a priest. But all such priests as pretend to be Christ’s successors in making a sacrifice for him, they be his most heinous and horrible adversaries. For never no person made a sacrifice of Christ, but he himself only."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-123",
      "id": "ap_ntb-123-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In conclusion, we hope to allow for a kind of argument “from the greater to the lesser.” If for Cranmer "), _c('i', [_vm._v("sola fide")]), _vm._v(" indeed governed and directed the two most dominant subjects of theology and piety leading into the sixteenth century—purgatory and the sacraments—we have reason to believe that justification by faith alone would serve in the same post for many other spheres of theology. So it appears that "), _c('i', [_vm._v("sola fide")]), _vm._v(" is the governor of Cranmer’s theological decisions. We turn now, beyond how "), _c('i', [_vm._v("sola fide")]), _vm._v(" is "), _c('i', [_vm._v("positioned")]), _vm._v(" in Cranmer’s theology, to unpack how the doctrine actually works in Cranmer’s theology.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 84
// module chunks = 0